<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="关键字 :" prop="title">
              <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="预约时间 :" prop="title">
              <el-date-picker v-model="time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
                start-placeholder="开始时间" @change="timeChange" end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="header">
        <cmpMyExport v-if="$route.query.type == 2" :params="form" @clearSelectsCall="clearSelectsCall"
          :chooseIds="chooseRowIds" chooseApi="/bsWwjdWeb/batchExport?arr=" searchApi="/bsWwjdWeb/batchExportAll">
        </cmpMyExport>

        <a class="to-back" @click="goBack">
          <i class="el-icon-back"></i>&nbsp;&nbsp;返回
        </a>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :row-key="
            row => {
              return row.schemeId
            }
          " :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" v-if="$route.query.type == 2" width="55">
          </el-table-column>
          <el-table-column label="序号">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="联系人"></el-table-column>
          <el-table-column prop="phone" label="联系方式"></el-table-column>

          <el-table-column prop="createTime" label="预约时间">
            <template slot-scope="scope">
              <span>{{
                $common.formatDateString(scope.row.createTime, 'yyyy-MM-dd')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jdzcName" label="场次名称"></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog title="查看详情" :close-on-press-escape="false" :visible.sync="dialogVisible" width="650px">
      <el-form class="g-form-grid" ref="form" :model="addForm" label-width="120px">
        <el-form-item label="场次名称 :" prop="title">
          <span>{{ addForm.jdzcName }}</span>
        </el-form-item>

        <el-form-item label="联系人姓名 :" prop="title">
          <span>{{ addForm.name }}</span>
        </el-form-item>

        <el-form-item label="联系方式 :" prop="title">
          <span>{{ addForm.phone }}</span>
        </el-form-item>

        <el-form-item label="身份证号 :" prop="title">
          <span>{{ addForm.card }}</span>
        </el-form-item>

        <el-form-item label="说明 :" prop="title">
          <span>{{ addForm.content }}</span>
        </el-form-item>

        <el-form-item label="文物图片 :" prop="title">
          <viewer :images="addForm.fileList" @inited="inited" rebuild
            :options="{ title: false, hide: this.hide, show: this.show }">
            <img v-show="false" v-for="(item, index) in addForm.fileList" :src="item.attPath" :key="index" />
          </viewer>

          <div class="flex-img">
            <div v-for="(item, index) in addForm.fileList" :key="index">
              <img class="img" @click="handlePreview(item.attPath)" :src="item.attPath" alt="" />
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'

export default {
  components: {
    cmpMyExport
  },
  data() {
    return {
      form: {
        type: this.$route.query.type,
        title: '',
        dateStart: '',
        dateEnd: ''
      },
      time: [],
      addForm: {},
      dialogVisible: false,
      chooseRowIds: '',
      value1: false,
      detailObj: {
        pics: [
          '/singleMuseum/attach/getImg?fileId=165664051862820476389168727411513&s=2217',
          '/singleMuseum/attach/getImg?fileId=165664051862820476389168727411513&s=2217'
        ]
      },
      from: 0,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      escFlag: true,
      total: 0,
      tableData: [],
      listLoading: true
    }
  },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      // 信息发布列表
      this.$http
        .get('/bsWwjdWeb/list', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          }
        })
    },

    timeChange(arr) {
      if (!arr) {
        this.form.dateStart = ''
        this.form.dateEnd = ''
      } else {
        this.form.dateStart = arr[0]
        this.form.dateEnd = arr[1]
      }
    },
    inited(viewer) {
      this.$viewer = viewer
    },

    hide() {
      setTimeout(() => {
        this.escFlag = true
      }, 500)
    },

    show() {
      // this.escFlag = false
      // this.$nextTick(() => {
      //   this.$viewer.show()
      // });
    },

    handlePreview(imgUrl) {
      for (let i in this.addForm.fileList) {
        if (this.addForm.fileList[i].attPath == imgUrl) {
          this.$viewer.index = i
        }
      }

      this.$viewer.show()
    },

    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 重置查询
    restList() {
      this.time = []
      this.form.dateStart = ''
      this.form.dateEnd = ''

      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    goBack() {
      this.$router.push({ path: '/website/identify' })
    },

    handleView(obj) {
      this.operation = 'view'
      this.$http.get('/bsWwjdWeb/find', { id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.picId) {
              this.imgUrl = res.result.picId
            }
          }
        }
      })
    },

    handleCreate(type, id) {
      this.$refs.dialogCreateInfo.init(type, id)
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  created() {
    console.log(this.$route.query)
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
.flex-img {
  display: flex;
  flex-wrap: wrap;
  .img {
    width: 120px;
    height: 120px;
    margin-right: 20px;
    margin-bottom: 10px;
    object-fit: cover;
  }
}
.header {
  position: relative;
}
.to-back {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
  color: #9699a2;
  cursor: pointer;
  &:hover {
    color: $primary;
  }
}
/deep/ .el-form-item__content {
  display: flex;
}
</style>
